import { useState } from "react";
import { Authentication, User } from "Interfaces/User";
import UserContextP, { FiltersInterface, OrderInterface, UserContextModel } from "Interfaces/Context";
import axios from "axios";
import { collection, limit, onSnapshot, orderBy, query, QueryFieldFilterConstraint, where } from "firebase/firestore";
import db from '../Service/Connections'; // Adjust the import according to your project structure

interface Props {
    children: React.ReactNode;
}
const UserContextProvider = (props:Props) => {
    //Informacion base del usuario
    const [user, setUser] = useState<User>(() => {
        try {
            const saved = sessionStorage.getItem('pt_user');
            return saved ? JSON.parse(saved) : { id: "", name: "", email: "", lastName: "" };
        } catch {
            return { id: "", name: "", email: "", lastName: "" };
        }
    });

    //Informacion de autenticacion
    const [authenticate, setAuth] = useState<Authentication>(() => {
        try {
            const saved = sessionStorage.getItem('pt_auth');
            return saved ? JSON.parse(saved) : { auth: false, uid: '', token: '' };
        } catch {
            return { auth: false, uid: '', token: '' };
        }
    });

    //Copia de la informacion
    const [dataCopy, setDataCopy] = useState<any>(() => {
        try {
            const saved = sessionStorage.getItem('pt_datacopy');
            return saved ? JSON.parse(saved) : undefined;
        } catch {
            return undefined;
        }
    });
   
    //Assigna un usuario
    const assignUser = (id: string, lastName: string, name: string, email: string) => {
        const newUser: User = {
            id: id,
            name: name,
            lastName: lastName,
            email: email
        };
        try {
            if (id) sessionStorage.setItem('pt_user', JSON.stringify(newUser));
            else sessionStorage.removeItem('pt_user');
        } catch (e) { }
        setUser(newUser);
    };

    //Asigna el estado del usuario
    const assignateAuth = (uid: string, authenticate: boolean, token: string) => {
        let authContent: Authentication = {
            auth: authenticate,
            uid: uid,
            token: token
        };
        try {
            if (token) sessionStorage.setItem('pt_auth', JSON.stringify(authContent));
            else sessionStorage.removeItem('pt_auth');
        } catch (e) { }
        setAuth(authContent);
    };

    //Copiado de la informacion
    const assignateCopyData = ( data:any ) =>{
        try {
            if (data) sessionStorage.setItem('pt_datacopy', JSON.stringify(data));
            else sessionStorage.removeItem('pt_datacopy');
        } catch (e) { }
        setDataCopy(data);
    };

    const navigateToSegment = async( navigate:any ) => {
        let data = {
            token: authenticate.uid,
            include: ["documentsAuthorized"]
        }

        await axios.post(`${process.env.REACT_APP_URL_ORDER}/settings/app/info/detail`,data).then((response)=>{
            let data = response.data.data
            if ( data.hasOwnProperty("authorizedOrderBuyer") && data.hasOwnProperty("authorizedOrderSeller") ) {
                if ( data.authorizedOrderSeller.includes(user.email) ) navigate("/update/order/stonks")
                else if (data.authorizedOrderBuyer.includes(user.email) ) navigate("/update/order/sold")
                else navigate("/auth/google/failure")
            }
        }).catch((error)=>{
            console.log(error.message)
        })
    }

    const getDocuments$ = async(filters: FiltersInterface[], orderType?: OrderInterface, limitValue?: number) => {
        return new Promise<any[]>((resolve, reject) => {
            let collectionRef = collection(db, "orders");
            let whereFilters: QueryFieldFilterConstraint[] = [];
            filters.forEach((filter) => whereFilters.push(where(filter.key, filter.operator, filter.value)));
            let q = query(collectionRef, ...whereFilters);

            if (orderType) q = query(q, orderBy(orderType.key, orderType.direction));
            if (limitValue) q = query(q, limit(limitValue));

            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                let documents: any[] = [];
                querySnapshot.forEach((doc) => {
                    documents.push({ id: doc.id, ...doc.data() });
                });
                resolve(documents);
                // Maneja los datos de los documentos según sea necesario
            }, (error) => {
                reject([]);
            });

            // Limpia el listener al desmontar el componente
            return () => unsubscribe();
        });
    }

    const separatorMiles = (value: number): string => {
        let newValue = (Math.round(value * 100) / 100).toFixed(2)
        return newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    //Crea el contexto en forma de etiqueta
    const usercontext: UserContextModel = {
        user,
        assignUser,
        dataCopy,
        assignateCopyData,
        authenticate,
        assignateAuth,
        getDocuments$,
        navigateToSegment,
        separatorMiles
    }

    return (
        <UserContextP.Provider value={usercontext} >
            {props.children }
        </UserContextP.Provider>
    );
};

export default UserContextProvider;